module.exports = __webpack_public_path__ + "static/img/news_xiangqing_tu3.b0d574c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/news_xiangqing_tu3.png
// module id = RoGn
// module chunks = 0